import React from 'react';
import Logo from './logo';
import { Link } from 'react-router-dom';
import './logged_out_web_styles.scss';
import WordSearchContainer from '../../containers/word_search';
import NewestWordsContainer from '../../containers/newest_words';
import MostTackedWordsContainer from '../../containers/most_tacked_words';

export default class LoggedOutWeb extends React.Component {
  render() {
    return(
      <div className='logged-out-web-home'>
        <Logo />
        <section>
          <h2>Hi. We're Yak Tack.</h2>
          <p>
            Yak Tack is an app that helps people remember words and improve their vocabulary.
            People are using Yak Tack to remember words right now:
          </p>
          <div className='try-it'>
            <NewestWordsContainer />
          </div>
        </section>
        <section className='blue-section'>
          <h2>Try it out!</h2>
          <div className='try-it'>
            <WordSearchContainer />
          </div>
          <p className='thirty-up'>
            Type any word you can think of above. We like "apocryphal" and "peripatetic."
          </p>
        </section>
        <section>
          <h2>It works. But don't take our word for it. We're featured in:</h2>
          <div className='row'>
            <div className='col-sm-4 as-seen-in'>
              <a href='https://www.makeuseof.com/best-websites-apps-that-improve-your-prose/'>
                <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/make-use-of.png' className="as-seen-logo" alt="Make Use Of" />
              </a>
            </div>
            <div className='col-sm-4 as-seen-in'>
              <a href='https://techcrunch.com/2021/04/15/yak-tack-is-a-super-simple-app-to-boost-vocabulary/'>
                <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/tech-crunch.jpg' className="as-seen-logo" alt="TechCrunch" />
              </a>
            </div>
            <div className='col-sm-4 as-seen-in'>
              <a href='https://hackernoon.com/how-the-yak-tack-algorithm-helps-you-remember-words-dm1z34vb'>
                <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/hackernoon-logo.png' className="as-seen-logo" alt="Hackernoon" />
              </a>
            </div>
          </div>
        </section>     
        <section className='app-stores blue-section'>
          <h2 className='center'>We're an Android and iOS app.</h2>
          <div className='row give-me-30-top'>
            <div className='col-sm-6 center'>
              <a href='https://play.google.com/store/apps/details?id=com.yaktackapp'>
                <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/google-play-badge.png' alt="Google Play" className='google-play' />
              </a>
            </div>
            <div className='col-sm-6 center'>
              <a href='https://apps.apple.com/us/app/yak-tack/id1530700944'>
                <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/download-on-app-store.png' alt="App Store" className='apple-app-store' />
              </a>
            </div>
          </div>
          <div className='row bust-free mobile-screenshots'>
            <div className='col-sm-2'>
              <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/screenshot_1_home.png' alt="home screen" />
            </div>
            <div className='col-sm-2'>
              <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/screenshot_2_word.png' alt="word screen" />
            </div>
            <div className='col-sm-2'>
              <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/screenshot_3_notification.png' alt="notification screen" />
            </div>
            <div className='col-sm-2'>
              <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/screenshot_4_tack_board.png' alt="tack-board screen" />
            </div>
            <div className='col-sm-2'>
              <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/screenshot_5_people_board.png' alt="people-board screen" />
            </div>
            <div className='col-sm-2'>
              <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/screenshot_6_points_board.png' alt="points-board screen" />
            </div>
          </div>
        </section>           
        <section>
          <h2>We help people remember words with spaced repetition.</h2>
          <p>
            Spaced repetition is a scientifically proven technique used to boost memory recall by flattening the Forgetting Curve. We use it. It combats
            a natural phenomemon called memory decay, in which words we remember become harder to retrieve over time.
          </p>
          <p>
            We use an algorithm based on the <a href="https://yaktack.substack.com/p/enter-leitner" rel="noopener noreferrer" target="_blank">Leitner system</a> that
            re-surfaces words at expanding intervals just before they fully decay, which ironically strenghens one's ability to remember them.
          </p>
          <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/forgetting-curve-with-intervals.png' alt='forgetting curve mitigated'></img>
          <p>
            In practice, when you want to remember what a word means, we remind you of it frequently at first, then less frequently
            as time goes on.
          </p>
          <p>
            We call this process "<b>tacking</b>."
          </p>
        </section>
        <section className='blue-section'>
          <h2>We're big around the world.</h2>
          <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/earth.png' className='world'></img>
          <p>
            People around the world are using Yak Tack to learn English.
            And we make it easy to remember what words mean in your native language.
          </p>
          <p>
            Check out the definition of "ostensibly" in <Link to='/words/ostensibly/ja'>Japanese</Link> or <Link to='/words/ostensibly/es'>Spanish</Link>.
          </p>
        </section>
        <section>
          <h2>Like newsletters? We have one.</h2>
          <a href="https://yaktack.substack.com/" rel='noopener noreferrer' target="_blank">Sign up for The Yak Tack</a>,
          our burgeoning newsletter about words, word trends, and how we build this thing.
        </section>
        <section className='blue-section'>
          <h2>We love words. We're tired of forgetting what they mean.</h2>
          <p>
            Ever engage in a conversation around a campfire and hear someone use the
            word <Link to='/words/ostensibly'>ostensibly</Link> a couple times? Ever pull out your phone to look
            it up?
          </p>
          <p>
            <i>ostensibly: as appears or is stated to be true, though not necessarily so; apparently</i>
          </p>
          <p>
            Ever peruse an article the following week, where "ostensibly" shows up, only to realize you forgot what
            it means?
          </p>
          <p>
            We have.
          </p>
        </section>
        <section>
          <h2>It's better with people.</h2>
          <p>
            We didn't know that "ostensibly" was a word until our friend used it around the campfire.
            Other people expose us to new words.
          </p>
          <p>
            We've made it easy for you to connect with people on Yak Tack who are learning new words too.
            When they start tacking a new word, we'll tell you about it. They'll be your campfire friend.
          </p>
          <p>
            Here are the most popular words this month. Click on a few to see who's been tacking them.
          </p>
          <div className='try-it'>
            <MostTackedWordsContainer />
          </div>
        </section>
        <section className='blue-section'>
          <h2>Hey power users, we're also headless.</h2>
          <p>
            What we mean is, you can use Yak Tack without using Yak Tack. Want to remember a word?
            Email word@yaktack.com with the word as the subject, and we'll take it from there. Power users love headless Yak Tack.
          </p>
          <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/email.png' className='shadow-image'></img>
        </section>
        <section>
          <h2>Try it. Type a word or term below, then click NEXT.</h2>
          <div className='try-it'>
            <WordSearchContainer />
          </div>
          <p className='thirty-up'>
            Type any word or term you can think of above. We like "erudite" and "pareto principle."
          </p>
        </section>
        <section className='blue-section'>
          <h2>Does it cost anything?</h2>
          <p>
            Yak Tack is fully functional for free. But for $2.00 (USD) per month, Yak Tack
            is even better. Don't worry about that now. Start tacking for free. We'll
            talk about money later if we need to.
          </p>
        </section>
        <section>
          <h2>Questions? Concerns? Feedback?</h2>
          <p>
            Send an email to <b>hello@yaktack.com</b>. Let's chat.
          </p>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/home/logged_out_web.jsx